import React from 'react';

function LandingSection({ children, className = '', id, soft = false }) {
  const classes = ['landing-section', soft && 'landing-section-soft', className].filter(Boolean).join(' ');
  return <section id={id} className={classes}><div className="landing-section-shell">{children}</div></section>;
}

export default LandingSection;
